import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVideoOff: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="video-off, cam-off"><path d="M14.25 19.25H2.75V4.75M7.75 4.75H15.25V12M15.25 12V10L21.25 7V17L15.25 14V12ZM2 3L16.5 21.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconVideoOff;
